import { withAppCrashIfException } from 'epic';
import { combineEpics, ofType } from 'redux-observable';
import { merge } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  dynamicTabResetAssociatedQuoteThunk,
  dynamicTabSetAssociatedQuoteThunk,
} from 'state/workspaces/dynamic/dynamic.thunks';
import { essentialTabSetAssociatedQuoteThunk } from 'state/workspaces/essential/thunks';
import {
  staticTabResetAssociatedQuoteThunk,
  staticTabSetAssociatedQuoteThunk,
} from 'state/workspaces/static/static.thunks';

export function staticTabSetAssociatedQuoteEpic(): EpicWithThunk {
  return (actions$, _state$, __) =>
    actions$.pipe(
      ofType('QUOTE_ACKED', 'PREVIOUS_QUOTE_LOAD_REQUESTED'),
      filter(a => a.workspace === 'static' || a.workspace === 'essential'),
      map(({ workspace, tabId, quoteId }) => {
        if (workspace === 'essential') {
          return essentialTabSetAssociatedQuoteThunk(tabId, quoteId);
        }

        return staticTabSetAssociatedQuoteThunk(tabId, quoteId);
      }),
    );
}

export function staticTabResetAssociatedQuoteEpic(): EpicWithThunk {
  return (actions$, _state$, __) =>
    merge(
      actions$.pipe(
        ofType('QUOTE_REMOVED'),
        filter(a => a.workspace === 'static'),
      ),
      actions$.pipe(ofType('QUOTE_STALE')).pipe(filter(a => a.workspace === 'static' && a.hasFormChanged)),
    ).pipe(map(({ tabId }) => staticTabResetAssociatedQuoteThunk(tabId)));
}

export function dynamicTabSetAssociatedQuoteEpic(): EpicWithThunk {
  return (actions$, _state$, __) =>
    actions$.pipe(
      ofType('QUOTE_ACKED', 'PREVIOUS_QUOTE_LOAD_REQUESTED'),
      filter(a => a.workspace === 'dynamic'),
      map(({ tabId, quoteId }) => dynamicTabSetAssociatedQuoteThunk(tabId, quoteId)),
    );
}

export function dynamicTabResetAssociatedQuoteEpic(): EpicWithThunk {
  return (actions$, _state$, __) =>
    merge(
      actions$.pipe(
        ofType('QUOTE_REMOVED'),
        filter(a => a.workspace === 'dynamic'),
      ),
      actions$.pipe(ofType('QUOTE_STALE')).pipe(filter(a => a.workspace === 'dynamic' && a.hasFormChanged)),
    ).pipe(map(({ tabId }) => dynamicTabResetAssociatedQuoteThunk(tabId)));
}

export const workspaceTabPersistAssociatedQuoteEpic = () =>
  combineEpics(
    withAppCrashIfException('staticTabSetAssociatedQuoteEpic', staticTabSetAssociatedQuoteEpic()),
    withAppCrashIfException('staticTabResetAssociatedQuoteEpic', staticTabResetAssociatedQuoteEpic()),
    withAppCrashIfException('dynamicTabSetAssociatedQuoteEpic', dynamicTabSetAssociatedQuoteEpic()),
    withAppCrashIfException('dynamicTabResetAssociatedQuoteEpic', dynamicTabResetAssociatedQuoteEpic()),
  );
